module.exports = __webpack_public_path__ + "img/tablet-alt.d7f38a9e.svg";